import { LinkModel } from '../../Forms/models/link.model';
import { ImageAlignmentEnum } from '../enums/image-alignment.enum';
import { ImagePropertiesApiModel } from '../../../api/pagebuilder/models/image-properties-api.model';
import { ImageSourceEnum } from '../enums/image-source.enum';

export class BriefingImagePropertiesModel {
    link?: LinkModel;
    caption?: string;
    displaySize?: number;
    width?: number;
    imageAlignment?: ImageAlignmentEnum;
    targetUrl?: string;
    altText?: string;
    url?: string;
    location?: number;
    imageSource?: ImageSourceEnum;

    // not part of API
    type?: string;
    mimeType?: string;
    name?: string;
    oldUrl?: string;
    showAltText?: boolean;
    naturalWidth?: number;
    naturalHeight?: number;
    hasError?: boolean;
    errorMessage: string;
    touched?: boolean;
    noThumbnail?: boolean;

    constructor(apiModel?: ImagePropertiesApiModel) {
        if (apiModel) {
            if (apiModel.link) {
                this.link = new LinkModel(apiModel.link);
            }
            if (apiModel.caption) {
                this.caption = apiModel.caption;
            }
            if (apiModel.displaySize) {
                this.displaySize = apiModel.displaySize;
            }
            if (apiModel.width) {
                this.width = apiModel.width;
            }
            if (apiModel.imageAlignment) {
                this.imageAlignment = apiModel.imageAlignment;
            }
            if (apiModel.targetUrl) {
                this.targetUrl = apiModel.targetUrl;
            }
            if (apiModel.altText) {
                this.altText = apiModel.altText;
                this.showAltText = true;
            }
            if (apiModel.url) {
                this.url = apiModel.url;
            }
            if (apiModel.type) {
                this.type = apiModel.type;
            }
            if (apiModel.mimeType) {
                this.mimeType = apiModel.mimeType;
            }
            if (apiModel.name) {
                this.name = apiModel.name;
            }
            if (apiModel.hasError) {
                this.hasError = apiModel.hasError;
            }
            if (apiModel.location || (apiModel.location === 0)) {
                this.location = apiModel.location;
            }
            if (apiModel.imageSource) {
                this.imageSource = apiModel.imageSource;
            } else {
                this.imageSource = ImageSourceEnum.NORMAL;
            }
        }
    }

    toApi(width?: number): any {
        const api = {} as ImagePropertiesApiModel;

        if (this.link) {
            api.link = this.link?.toApi();
        }
        if (this.caption) {
            api.caption = this.caption;
        }
        if (this.displaySize) {
            api.displaySize = this.displaySize;
        }
        if (this.width) {
            api.width = this.width;
        }
        if (width) {
            api.width = width;
        }
        if (this.imageAlignment) {
            api.imageAlignment = this.imageAlignment;
        }
        if (this.targetUrl) {
            api.targetUrl = this.targetUrl;
        }
        if (this.altText) {
            api.altText = this.altText;
        }
        if (this.url) {
            api.url = this.url;
        }
        if (this.location || (this.location === 0)) {
            api.location = this.location;
        }

        if (this.imageSource) {
            api.imageSource = this.imageSource;
        } else {
            api.imageSource = ImageSourceEnum.NORMAL;
        }

        return api;
    }

    equals(other?: BriefingImagePropertiesModel): boolean {
        if (!other) {
            return false;
        }

        if ((this.link || other.link) && !this.link?.equals(other.link)) {
            return false;
        }

        if (this.caption !== other.caption) {
            return false;
        }
        if (this.displaySize !== other.displaySize) {
            return false;
        }
        if (this.width !== other.width) {
            return false;
        }
        if (this.imageAlignment !== other.imageAlignment) {
            return false;
        }
        if (this.targetUrl !== other.targetUrl) {
            return false;
        }
        if (this.altText !== other.altText) {
            return false;
        }
        if (this.url !== other.url) {
            return false;
        }
        if (this.location !== other.location) {
            return false;
        }

        if (this.imageSource !== other.imageSource) {
            return false;
        }

        return true;
    }

    clone(): BriefingImagePropertiesModel {
        const apiModel = this.toApi();
        const clone = new BriefingImagePropertiesModel(apiModel);

        return clone;
    }
}
